import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

class Delete extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            nombre: '',
            host: '',
            username: '',
            password: '',
            port: ''
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    getData = () => {
        const { nombre, host, username, password, port } = this.state;
        return { nombre, host, username, password, port };
    }

    resetForm() {
        this.setState({
            nombre: '',
            host: '',
            username: '',
            password: '',
            port: ''
        });
        if (this.props.onClose) this.props.onClose();
    }

    setSelects(data) {
        this.setState(() => ({
            nombre: data.nombre,
            host: data.host,
            username: data.username,
            password: data.password,
            port: data.port
        }));
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.email.casillas.delete}
                postUrl={api.email.casillas.delete}
                onPreSubmit={this.getData}
                onSubmit={(e) => this.props.onSubmit(e)}
                id={this.props.id}
                successMessage={"La Casilla de Mail ha sido eliminada con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Eliminar Casilla de Mail"}
                buttonTitle={"Eliminar"}
                buttonIcon={"fa fa-trash fa-lg"}
                saveButton={true}
                buttonClass={"btn-danger"}
                closeButton={true}
                danger={true}
                saveButtonLabel={"Eliminar"}
                onGotData={(data) => this.setSelects(data)}
                onClose={() => this.resetForm()}
                className="ui-modal-dialog"
            >
                <div className="ui-form">
                    <div className="ui-row-2">
                        <div className="ui-field">
                            <label>Nombre</label>
                            <input
                                type="text"
                                name="nombre"
                                className="form-control"
                                value={this.state.nombre}
                                disabled={true}
                            />
                        </div>
                        <div className="ui-field">
                            <label>Host</label>
                            <input
                                type="text"
                                name="host"
                                className="form-control"
                                value={this.state.host}
                                disabled={true}
                            />
                        </div>
                    </div>
                    <div className="ui-row-2">
                        <div className="ui-field">
                            <label>Usuario</label>
                            <input
                                type="text"
                                name="username"
                                className="form-control"
                                value={this.state.username}
                                disabled={true}
                            />
                        </div>
                        <div className="ui-field">
                            <label>Puerto</label>
                            <input
                                type="text"
                                name="port"
                                className="form-control"
                                value={this.state.port}
                                disabled={true}
                            />
                        </div>
                    </div>
                    <div className="ui-row-1">
                        <div className="ui-field">
                            <label>Contraseña</label>
                            <input
                                type="password"
                                name="password"
                                className="form-control"
                                value={this.state.password}
                                disabled={true}
                            />
                        </div>
                    </div>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Delete;



// WEBPACK FOOTER //
// ./src/views/Config/Casillas/Delete.js